import React from 'react'
import { observer } from 'mobx-react-lite'
import AgentPackages from './../../../../components/shared/AgentPackages.component'
import Store from './../../shared/Enrollment.store'
import { isWhiteLabelUpline, WHITE_LABEL_RECRUIT_USERTYPE_ID } from './../../../../shared/utilities/whiteLabel.function'
import { MDBContainer, MDBBtn, MDBCol, MDBCollapse, MDBRow } from 'mdb-react-ui-kit'

import './IntakeFormPackageSelection.scss'

const IntakeFormPackageSelection = ({ onComplete }) => {
  const selectPackages = usertypeId => {
    if (parseInt(usertypeId) === 111 && isWhiteLabelUpline(Store.upline)) usertypeId = WHITE_LABEL_RECRUIT_USERTYPE_ID

    Store.usertypeId = usertypeId
    onComplete(
      [111, WHITE_LABEL_RECRUIT_USERTYPE_ID].indexOf(parseInt(usertypeId)) > -1 ? true : 'IntakeFormAcceptance'
    )
  }

  return (
    <MDBContainer fluid id='IntakeFormPackageSelectionComponent' className='intake-form'>
      <MDBRow>
        <MDBCol size='12' className='stage-heading'>
          <h3>
            <strong>Agent Package Selection</strong>
          </h3>
        </MDBCol>
      </MDBRow>
      <MDBRow>
        <MDBCol size='12' style={{ padding: '0' }}>
          <AgentPackages
            canEnroll={true}
            excludeUsertypeIds={isWhiteLabelUpline(Store.upline) ? [91] : Store.showAffiliate ? [] : [111]}
            pkgSelectors={{
              111: (
                <MDBCollapse open={Store.isAuthenticated()}>
                  <MDBBtn
                    className='pkg-btn mt-2 mb-2'
                    onClick={() => selectPackages(111, [])}
                    disabled={Store.isCompleting}
                  >
                    {Store.isCompleting ? (
                      <>
                        <i className='fa fa-spin fa-spinner'></i>
                      </>
                    ) : (
                      <>
                        Become an
                        <br />
                        Affiliate Agent
                      </>
                    )}
                  </MDBBtn>
                </MDBCollapse>
              ),
              // white-label leaders may enroll affiliate agents only —
              // hide the Signature Agent option when the upline is white-label.
              ...(isWhiteLabelUpline(Store.upline)
                ? {}
                : {
                    91: (
                      <MDBCollapse open={Store.isAuthenticated()}>
                        <MDBBtn
                          className='pkg-btn mt-2 mb-2'
                          onClick={() => selectPackages(91, [])}
                          disabled={Store.isCompleting}
                        >
                          {Store.isCompleting ? (
                            <>
                              <i className='fa fa-spin fa-spinner'></i>
                            </>
                          ) : (
                            <>
                              Become a<br />
                              Signature Agent
                            </>
                          )}
                        </MDBBtn>
                      </MDBCollapse>
                    ),
                  }),
            }}
          />
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  )
}

export default observer(IntakeFormPackageSelection)
